import React from "react";
import ValueStatement from "./ValueStatement/valueStatement";
import PropTypes from 'prop-types';

const Banner = ({ campaignDefaults }) => (
  <section className="cobranded-page-banner banner-img">
    <ValueStatement campaignDefaults={campaignDefaults} />
  </section>
);

Banner.propTypes = {
  campaignDefaults: PropTypes.shape({
    minApr: PropTypes.string.isRequired
  }).isRequired
};

export default Banner;
